import { BaseWebComponentRepository } from '../../../../framework/BaseWebComponentRepository';
import { DeployerGridDataProviderFactory } from '../factory/DeployerGridDataProviderFactory';
import { DeployerGridBaseDataProvider } from '../dataProvider/DeployerGridBaseDataProvider';
import { DeployerRelayData } from '../types';
import { UpdateSupaMachinesResponse } from '../types/deployer-grid-responses';

export class DeployerGridRepository extends BaseWebComponentRepository {
  public dataProviderFactory: DeployerGridDataProviderFactory;
  public dataProvider: DeployerGridBaseDataProvider;

  constructor() {
    super();
    this.initialSetup({
      dataProviderFactory: new DeployerGridDataProviderFactory(),
    });
  }

  public async updateSupaMachines(records: Array<DeployerRelayData>): Promise<UpdateSupaMachinesResponse> {
    return this.dataProvider.updateSupaMachines(records);
  }
}
